export const getEmploymentsFrag = `
    id
    dateFrom
    dateTo
    serviceId
    service {
        name
    }
    employmentTypeName
    organizationId
    
    
    contract
    specificName
    workloadType
    workloadSize
    scopeOfWork
    note
    workplaces {
        workplaceId
        dateFrom
        dateTo
    }
`;
